import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { HomeModule } from '../home/home.module';
import { ProductsRoutingModule } from './products-routing.module';
import { ListComponent } from './list/list.component';
import { ProductUpdateComponent } from './product-update/product-update.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import {MatTableModule} from "@angular/material/table"
import { MatPaginatorModule, MatSortModule } from '@angular/material';

@NgModule({
  declarations: [ListComponent, ProductUpdateComponent],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    SharedModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ]
})
export class ProductsModule { }
